import { useState, useEffect } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import authFetch from '../utils/authFetch';

const todayKey = () => `task_reminder_${new Date().toISOString().split('T')[0]}`;

const TaskReminderBanner = () => {
  const [open,  setOpen]  = useState(false);
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem(todayKey())) return;
    if (!localStorage.getItem('auth_token')) return;
    authFetch('/tasks/urgent')
      .then(r => r.json())
      .then(tasks => {
        if (Array.isArray(tasks) && tasks.length > 0) {
          setCount(tasks.length);
          setOpen(true);
        }
      })
      .catch(() => {});
  }, []);

  const dismiss = () => {
    setOpen(false);
    try { localStorage.setItem(todayKey(), '1'); } catch (_) {}
  };

  return (
    <Snackbar
      className="crm-task-reminder"
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={dismiss}
    >
      <Alert
        severity="warning"
        variant="filled"
        onClose={dismiss}
        action={
          <Button color="inherit" size="small" sx={{ fontWeight: 700 }}
            onClick={() => { dismiss(); navigate('/tasks'); }}>
            לצפייה
          </Button>
        }
        sx={{ direction: 'rtl', alignItems: 'center' }}
      >
        {count === 1
          ? 'יש לך משימה דחופה אחת — דדליין היום או מחר'
          : `יש לך ${count} משימות דחופות — דדליין היום או מחר`}
      </Alert>
    </Snackbar>
  );
};

export default TaskReminderBanner;
